import { useMatches } from '@tanstack/router'
import { useEffect } from 'react'

import { COUNTRY } from '../constants/countries'

export default function useViewContent() {
  const matches = useMatches()
  const pathname = matches.slice(-1)[0].pathname

  useEffect(() => {
    fbq?.('track', 'ViewContent', {
      content_name: pathname,
      value: 1,
      currency: COUNTRY.currency,
    })
  }, [pathname])
}
